import {createSvgIcon} from '../create-svg-icon';

export const DetailsIcon = createSvgIcon(
  <path d="M12 3 2 21h20L12 3zm1 5.92L18.6 19H13V8.92zm-2 0V19H5.4L11 8.92z" />
, 'DetailsOutlined');
